<template>
  <a
    @click="goPage"
    @mouseover="onMouseOver"
    @mouseout="onMouseOut"
    :class="{
      'mouse-in': status === 'in',
      'mouse-out': status === 'out'
    }"
    class="link font-14 padding-y-8 padding-left-5 position-relative font-light"
    ><span v-html="title"></span
  ></a>
</template>
<script >
import { onMounted, ref } from '@vue/composition-api';
import { debounce } from 'lodash-es';
import { useRouter } from '@/hooks';
import useDrawMenu from '../hooks/useDrawMenu.js';
import store from '@/store';
import { getStore } from '@/util/store';
const __sfc_main = {};
__sfc_main.props = {
  title: {
    type: String,
    default: ''
  },
  path: {
    type: String,
    default: ''
  },
  item: {
    type: Object,
    default: () => {}
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const router = useRouter();
  const props = __props;
  const status = ref('');
  const onMouseOver = debounce(() => {
    status.value = 'in';
  }, 10);
  const onMouseOut = debounce(() => {
    status.value = 'out';
  }, 10);
  const {
    getCommonMenu
  } = useDrawMenu();
  const goPage = () => {
    const flag = getStore({
      name: 'firstVisitEditor'
    });
    if (!flag) {
      return;
    }
    if (props.path) {
      router.push(props.path);
      store.commit('SET_OPEN', false);
    }
    getCommonMenu({
      ...props.item,
      name: props.item.label
    });
  };
  onMounted(() => {});
  return {
    status,
    onMouseOver,
    onMouseOut,
    goPage
  };
};
export default __sfc_main;
</script>
<style scoped lang="scss">
  @keyframes ghost {
    0% {
      transform: translateX(0) scale(0);
    }

    100% {
      transform: translate(10px) scale(1);
    }
  }

  @keyframes ghost-out {
    0% {
      transform: translate(10px) scale(1);
    }

    60% {
      transform: translateX(100%) scale(0);
    }

    100% {
      transform: scale(0);
    }
  }

  .link {
    text-decoration: none;
    cursor: pointer;
    color: #666;
    overflow: hidden;
    transition: all 0.3s;
    width: 50%;
    box-sizing: border-box;

    // &:after {
    //   content: '';
    //   display: flex;
    //   justify-content: center;
    //   position: absolute;
    //   height: 1px;
    //   background-color: #4292ff;
    //   bottom: 0;
    //   left: 0;
    //   width: 30%;
    //   transform: scale(0);
    // }

    &.mouse-in {
      &:after {
        transform-origin: left center;
        animation: ghost 0.3s forwards;
      }
    }

    &.mouse-out {
      &:after {
        animation: ghost-out 0.2s forwards;
      }
    }

    &:visited {
      color: lighten(#4292ff, 10%);
    }

    &:hover {
      color: #4292ff;
    }

    &:active {
      /* 鼠标点击状态 */
      color: darken(#4292ff, 20%);
    }
  }
</style>
